import { useId } from 'react';

import { Link, Text } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';

import { trackClick } from '../../../../features/track';
import brochureUrl from '../../../brochureUrl';
import { SUPPORT_EMAIL } from '../../../constants';

const footerLinkClass = {
  textDecoration: 'underline',
  fontSize: 'fontSize.50',
  lineHeight: 'lineHeight.30',
  color: 'text.weak',
};

export const NonAdvisedLinks: React.FC = () => {
  const footerNavLabel = useId();

  return (
    <nav
      aria-labelledby={footerNavLabel}
      className={css({
        display: 'flex',
        paddingTop: 'space.400',
        paddingBottom: 'space.400',
        justifyContent: 'start',
        alignItems: 'baseline',
      })}
    >
      <Text as="span" color="text.weak" css={{ paddingRight: 'space.200', fontWeight: 'medium' }} id={footerNavLabel}>
        Questions?
      </Text>
      <ul className={css({ display: 'flex', gap: 'space.200', listStyleType: 'none', margin: '0', padding: '0' })}>
        <li>
          <Link
            css={footerLinkClass}
            onClick={() => trackClick({ name: 'FAQ' })}
            target="_blank"
            href={brochureUrl('/help')}
          >
            Support Center
          </Link>
        </li>
        <li>
          <Link
            css={footerLinkClass}
            onClick={() => trackClick({ name: 'ContactUs' })}
            target="_blank"
            href={brochureUrl('/contact')}
          >
            Contact Us
          </Link>
        </li>
        <li>
          <Link css={footerLinkClass} href={`mailto:${SUPPORT_EMAIL}`}>
            Email Us
          </Link>
        </li>
      </ul>
    </nav>
  );
};
